import { gql } from "@apollo/client"
import { ChangeCompanyInput, ChangeCompanyPayload } from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import { CountrySalesFields } from "~/shared/fragments/CountrySalesFields"

export const GENERAL_COMPANY_UPDATE_COMPANY = gql`
  mutation GeneralCompanyUpdateCompany(
    $companyId: ID!
    $name: String
    $legallyRegisteredName: String
    $countryCode: String
    $size: CompanySize
    $publicUrl: String
    $avatarSignedId: String
    $approverId: ID
    $registrationNumber: String
    $onboardingPurpose: [CompanyPurpose!]
    $onboardingFirstHireTimescale: [CompanyFirstHireTimescale!]
    $onboardingNumberOfHiresPlanned: CompanyPlannedHires
    $onboardingPlannedCountriesToHireFrom: [String!]
    $paymentCurrencyCode: String
    $billingAddress: AddressArguments
    $countrySales: CountrySalesInput
    $taxNumber: String
    $businessControllers: [String!]
  ) {
    changeCompany(
      input: {
        companyId: $companyId
        name: $name
        legallyRegisteredName: $legallyRegisteredName
        size: $size
        countryCode: $countryCode
        publicUrl: $publicUrl
        avatarSignedId: $avatarSignedId
        approverId: $approverId
        registrationNumber: $registrationNumber
        onboardingPurpose: $onboardingPurpose
        onboardingFirstHireTimescale: $onboardingFirstHireTimescale
        onboardingNumberOfHiresPlanned: $onboardingNumberOfHiresPlanned
        onboardingPlannedCountriesToHireFrom: $onboardingPlannedCountriesToHireFrom
        paymentCurrencyCode: $paymentCurrencyCode
        billingAddress: $billingAddress
        countrySales: $countrySales
        businessControllers: $businessControllers
        taxNumber: $taxNumber
      }
    ) {
      company {
        id
        name
        legallyRegisteredName
        size
        countryCode
        paymentCurrencyCode
        publicUrl
        avatarUrl
        registrationNumber
        approver {
          id
          name
        }
        countrySales {
          ...CountrySalesFields
        }
        invoicingSettings {
          taxNumber
        }
        businessControllers
      }
      errors
    }
  }
  ${CountrySalesFields}
`

export default (
  options?: InjectedOptions<{ changeCompany: ChangeCompanyPayload }, ChangeCompanyInput>,
) =>
  useMutation<{ changeCompany: ChangeCompanyPayload }, ChangeCompanyInput>(
    GENERAL_COMPANY_UPDATE_COMPANY,
    options,
  )
